// src/components/digital_twin/twin_engine/ui/MaintenanceTab.js
// Maintenance history from /asset-maintenance plus, for wells, the open work orders on the
// well and its linked drainage.
import React, { memo } from 'react';
import { Box, Flex, Text, VStack } from '@chakra-ui/react';
import { FaTools, FaClipboardCheck } from 'react-icons/fa';
import { Empty, LevelBadge, Section, fmtDate, useTwinTokens } from './ui';

function MaintenanceTab({ sources }) {
  const t = useTwinTokens();
  const list = sources.maintenance?.data || [];
  const wos = sources.wellIntel?.data?.work_orders || [];
  if (!list.length && !wos.length) {
    return <Empty icon={FaTools} title="No maintenance recorded">{sources.maintenance?.status === 'error' ? sources.maintenance.error : 'No maintenance records or open work orders exist for this asset in FlowSense.'}</Empty>;
  }
  return (
    <VStack align="stretch" spacing={4}>
      {wos.length > 0 && (
        <Section title={`Open work orders (${wos.length})`} icon={FaClipboardCheck}>
          {wos.map((w) => (
            <Flex key={w.id} justify="space-between" py={1.5} borderBottomWidth="1px" borderColor={t.border} _last={{ borderBottomWidth: 0 }} gap={2}>
              <Box minW={0}><Text fontSize="13px" fontWeight="700" noOfLines={1}>{w.title || w.description || `Work order ${w.id}`}</Text>
                <Text fontSize="11px" color={t.muted}>#{w.id}{w.created_at ? ` · opened ${fmtDate(w.created_at)}` : ''}{w.due_date ? ` · due ${fmtDate(w.due_date)}` : ''}{w.overdue ? ' · OVERDUE' : ''}</Text></Box>
              <LevelBadge level={/urgent|critical|high/i.test(w.priority) ? 'high' : 'info'}>{w.status || 'open'}</LevelBadge>
            </Flex>
          ))}
        </Section>
      )}
      {list.length > 0 && (
        <Section title={`Maintenance history (${list.length})`} icon={FaTools}>
          {list.map((m) => (
            <Box key={m.id} py={2} borderBottomWidth="1px" borderColor={t.border} _last={{ borderBottomWidth: 0 }}>
              <Flex justify="space-between" gap={2}>
                <Text fontSize="13px" fontWeight="700">{m.type}</Text>
                <Text fontSize="12px" color={t.muted} flexShrink={0}>{fmtDate(m.date)}</Text>
              </Flex>
              {m.description && <Text fontSize="13px" color={t.muted}>{m.description}</Text>}
              <Text fontSize="11px" color={t.faint}>{[m.status, m.technician, m.cost != null ? `$${m.cost.toLocaleString()}` : null].filter(Boolean).join(' · ')}</Text>
            </Box>
          ))}
        </Section>
      )}
    </VStack>
  );
}

export default memo(MaintenanceTab);
